module.exports = __webpack_public_path__ + "img/6917aa5.svg";